import React, { useEffect } from "react";
import { useRouter, withRouter } from "next/router";
import ReactGA_4 from "react-ga4";
import dynamic from "next/dynamic";
import { connect } from "react-redux";
import { FlexContainer } from "@components/ui/flex_container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWrench } from "@fortawesome/free-solid-svg-icons";
import {
    SharedSearchBarProvider,
    SearchBarSlot,
} from "@components/SharedSearchBar/SharedSearchBar";

const Page = dynamic(() => import("@components/layout/page"));
const FrontPage = dynamic(() => import("@components/front_page/front_page"));
const SearchResults = dynamic(() => import("@components/front_page/search_results_container"));

function TorgidPage() {
    const router = useRouter();

    React.useEffect(() => {
        ReactGA_4.send("pageview");
    }, []);

    const [startedSearching, setStartedSearching] = React.useState(false);

    useEffect(() => {
        if (router.query.q) {
            setStartedSearching(true);
        }
    }, [router.query.q]);

    // Á farsíma: þegar leit hefst færist leitarreiturinn upp í hausinn, svo við skrunum
    // SAMSTUNDIS upp á topp til að hausinn (og reiturinn) sjáist. Algild leið sem virkar í
    // öllum vöfrum: núllstilla window, document-skrunfletina OG öll skrunanleg element upp
    // frá efninu. Lyklaborðið (sérstaklega Android Chrome) skrunar að fókuseraða reitnum
    // eftir á, svo við ítrekum nokkrum sinnum + þegar "visual viewport" sest.
    useEffect(() => {
        if (!startedSearching || typeof window === "undefined" || window.innerWidth > 768) {
            return undefined;
        }
        const scrollToTop = () => {
            window.scrollTo(0, 0);
            [document.scrollingElement, document.documentElement, document.body].forEach((el) => {
                if (el) {
                    el.scrollTop = 0;
                }
            });
            // Núllstilla hvaða skrunanlega forföður sem er (ef skrun-ílátið er ekki window).
            let el = document.getElementById("page-content");
            while (el && el !== document.body) {
                if (el.scrollHeight > el.clientHeight) {
                    el.scrollTop = 0;
                }
                el = el.parentElement;
            }
        };

        scrollToTop();
        const rafId = requestAnimationFrame(scrollToTop);
        const timers = [setTimeout(scrollToTop, 50), setTimeout(scrollToTop, 250), setTimeout(scrollToTop, 500)];
        const vv = window.visualViewport;
        if (vv) {
            vv.addEventListener("resize", scrollToTop);
        }
        return () => {
            cancelAnimationFrame(rafId);
            timers.forEach(clearTimeout);
            if (vv) {
                vv.removeEventListener("resize", scrollToTop);
            }
        };
    }, [startedSearching]);

    // Einn sameiginlegur leitarreitur fyrir bæði forsíðu og haus. Hann er aldrei
    // fjarlægður úr DOM-trénu — aðeins færður sjónrænt — svo fókus og farsímalyklaborð
    // haldast þegar notandinn byrjar að skrifa.
    const sharedSearchBarProps = {
        showGoogle: true,
        maxWidth: 900,
        onChange: (query) => {
            if (query) {
                setStartedSearching(true);
            }
        },
    };

    return (
        <SharedSearchBarProvider searchBarProps={sharedSearchBarProps}>
            {router.query.q ? (
                <Page
                    showsSearchBar
                    showsFooter={false}
                    searchBarSlot={<SearchBarSlot mode="header" style={{ height: 40 }} />}
                >
                    <SearchResults query={router.query.q} />
                </Page>
            ) : (
                <Page
                    showsSearchBar={startedSearching}
                    showsFooter={!startedSearching}
                    searchBarSlot={
                        startedSearching ? <SearchBarSlot mode="header" style={{ height: 40 }} /> : null
                    }
                >
                    <FlexContainer column style={{ flexGrow: 1 }}>
                        {/* <Notice text="Truflanir eru á kerfum 1819. Unnið er að viðgerð. Við afsökum þau óþægindi sem þetta kann að valda." /> */}
                        <FrontPage startedSearching={startedSearching} />
                    </FlexContainer>
                </Page>
            )}
        </SharedSearchBarProvider>
    );
}

const mapState = (state) => {
    return {
        name: state.name,
    };
};

const mapDis = () => {
    return {
        callAction: () => {},
    };
};

function Notice({ text }) {
    return (
        <div
            style={{
                backgroundColor: "#cc6d1822",
                color: "#cc6d18",
                flexGrow: 1,
                padding: "10px 15px",
                borderRadius: 100,
                textAlign: "center",
                maxWidth: 1018,
                alignSelf: "center",
            }}
        >
            <FontAwesomeIcon icon={faWrench} style={{ marginRight: 10, marginLeft: 5 }} />
            {text}
        </div>
    );
}

export default connect(mapState, mapDis)(withRouter(TorgidPage));
